import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { ICmsConfig } from '@icms/core/resource/config/icms-config';
export const CMS_CONFIG_CHECKOUT = 'checkout';

export interface IICmsConfigCheckoutDataContent extends IConfigData {
    donationProductId?: number;
}
export interface IICmsConfigCheckoutData extends ICmsConfig<IICmsConfigCheckoutDataContent> {}
ICmsContentService.registerConfig({
    id: CMS_CONFIG_CHECKOUT,
    name: 'Checkout configuration',
    fields: [
        {
            key: 'donationProductId',
            type: NICmsContentField.EFieldType.number,
            title: 'Donation product id'
        }
    ]
});
